import { FC, useState, createContext } from 'react';

interface SidebarContextType {
  sidebarToggle: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  sidebarCollapsed: boolean;
  toggleSidebarCollapse: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const SidebarContext = createContext<SidebarContextType>(
  {} as SidebarContextType
);

export const SidebarProvider: FC = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsedState] = useState(false);

  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };
  const toggleSidebarCollapse = () => {
    setSidebarCollapsedState(!sidebarCollapsed);
  };
  const setSidebarCollapsed = (collapsed: boolean) => {
    setSidebarCollapsedState(collapsed);
  };

  return (
    <SidebarContext.Provider
      value={{
        sidebarToggle,
        toggleSidebar,
        closeSidebar,
        sidebarCollapsed,
        toggleSidebarCollapse,
        setSidebarCollapsed
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
